import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig'; 

const PromoCodeList = () => {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const currentPage = useRef(1);

  useEffect(() => {
    getPaginatedPromotions();
  }, []);


  
    // ✅ Define getPaginatedUsers inside the component
    const getPaginatedUsers = async () => {
      try {
        const res = await axios.get(
          `${apiConfig.baseURL}/api/admin/paginatedPromoCodeList?page=${currentPage.current}&limit=${limit}`
        );
        const sortedData = res.data.result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setData(sortedData);
        setPageCount(res.data.pageCount);
      } catch (err) {
        console.error(err);
      }
    };
  
    useEffect(() => {
      currentPage.current = 1;
      getPaginatedUsers();
    }, [limit]);
  
    const handleDelete = async (id) => {
      if (!window.confirm("Delete this promotion?")) return;
      try {
        await axios.delete(`${apiConfig.baseURL}/api/admin/promotion_manage/${id}`);
        alert("Deleted Successfully");
        getPaginatedUsers(); // ✅ call the defined function here
      } catch (err) {
        console.error(err);
      }
    };
  


  const getPaginatedPromotions = async () => {
    try {
      const res = await axios.get(
        `${apiConfig.baseURL}/api/admin/paginatedPromoCodeList?page=${currentPage.current}&limit=${limit}`
      );
      const sortedData = res.data.result.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setData(sortedData);
      setPageCount(res.data.pageCount);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedPromotions();
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.active a {
      background-color: #0366d6;
      border-color: transparent;
      color: white;
      min-width: 32px;
    }
    li.disabled a {
      color: grey;
    }
  `;

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Promotion List</h4>
                <Link to="/promotion-create">
                  <button type="button" className="btn btn-success float-right">
                    Create Promotion
                  </button>
                </Link>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Promotion Name</th>
                        <th>Type</th>
                        <th>Bonus</th>
                        <th>Bonus Type</th>
                        <th>Category</th>
                        <th>Turnover</th>
                        <th>Status</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Banner</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                 <tbody>
                  {data.map((promo) => (
                    <tr key={promo._id}>
                       <td>{promo.promotionName}</td>
                          <td>{promo.promotionType}</td>
                          <td>{promo.bonusAmount}</td>
                          <td>{promo.bonusType}</td>
                          <td>{promo.bonusCategory}</td>
                          <td>{promo.turnover || "-"}</td>
                          <td>{promo.status}</td>
                          <td>{new Date(promo.startTime).toLocaleString()}</td>
                          <td>{new Date(promo.endTime).toLocaleString()}</td>
                          <td>
                            {promo.bannerImage ? (
                              <img
                                src={`${apiConfig.baseURL}/images/${promo.bannerImage}`}
                                alt="Banner"
                                style={{ width: "80px", height: "50px", objectFit: "cover" }}
                              />
                            ) : (
                              "No Image"
                            )}
                          </td>
                        <td>
                          <button
                            onClick={() => history.push(`/promotion-edit/${promo._id}`)}
                            className="btn btn-warning btn-sm"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDelete(promo._id)}
                            className="btn btn-danger btn-sm"
                          >
                            Delete
                          </button>
                        </td>
                    </tr>
                  ))}
                </tbody>

                  </table>

                  <MyPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PromoCodeList;
